import { Routes, Route } from "react-router-dom";

import { Suspense, lazy } from "react";
import DetailPost from "pages/post/Index.jsx";
import Loader from "../components/kits/Loader/Loader.tsx";

import ProtectedRoute from "./ProtectedRoute.tsx";
import FavoritePage from "pages/FavoritePage.jsx";
import BrandManagement from "components/pages/BrandManagement.jsx";
import UploadExcel from "pages/UploadExcel.jsx";

import AppointmentSystem from "pages/AppointmentSystem";
const AppointmentBooking = lazy(() => import("pages/appointment/AppointmentBooking"));
const SelectTime = lazy(() => import("pages/appointment/SelectTime"));
const ConfirmAppointment = lazy(() => import("pages/appointment/ConfirmAppointment"));
const ReservationForm = lazy(() => import("pages/ReservationForm"));
const AppointmentManagement = lazy(() => import("components/admin-panel/appointment-management/AppointmentManagement"));
const ServiceManagement = lazy(() => import("components/admin-panel/appointment-management/ServiceManagement"));
const ScheduleManagement = lazy(() => import("components/admin-panel/appointment-management/ScheduleManagement"));
const BlockedDatesManagement = lazy(() => import("components/admin-panel/appointment-management/BlockedDatesManagement"));
const ReservationManagement = lazy(() => import("components/admin-panel/appointment-management/ReservationManagement"));

const AdminLayout = lazy(() => import("components/layout/AdminLayout"));
const Layout = lazy(() => import("components/layout/layout/Layout"));
const Home = lazy(() => import("../pages/Svh/Home"));
const Blog = lazy(() => import("pages/Blog"));
const Article = lazy(() => import("pages/SingleArticle"));
const SingleProduct = lazy(() =>
  import("components/pages/single-product/SingleProduct")
);
const AllPages = lazy(() => import("pages/AllPages"));
const About = lazy(() => import("../pages/Svh/AboutUs/About"));
const Store = lazy(() => import("pages/Store"));
const Category = lazy(() => import("components/pages/Category"));
const Profile = lazy(() => import("components/profile/Profile"));
const CustomerMessage = lazy(() => import("pages/CustomerMessage"));
const CustomerOrders = lazy(() => import("pages/CustomerOrders"));
const AdminDashboard = lazy(() => import("pages/AdminDashboard"));
const AdminFinancial = lazy(() => import("pages/AdminFinancial"));
const AdminOrders = lazy(() => import("pages/AdminOrder"));
const UserManagement = lazy(() => import("pages/User_Management"));
const ClueManagement = lazy(() =>
  import("../components/admin-panel/clue-management/ClueManagement")
);
const CampainManagement = lazy(() =>
  import("../components/admin-panel/campain-management/CampainManagement")
);
const CategoryManagement = lazy(() =>
  import("components/admin-panel/CategoryManagement/CategoryManagement")
);
const OptionManagement = lazy(() =>
  import("../components/admin-panel/option-management/OptionManagement")
);
const CustomerClub = lazy(() =>
  import("../components/admin-panel/customerClub")
);
const SubCategory = lazy(() => import("components/subCategory/Index.jsx"));
const CustomerLayout = lazy(() => import("components/layout/CustomerLayout"));

export default function AllRoutes() {
  return (
    <Suspense
      fallback={
        <div className="min-vh-100 min-vw-100 d-flex justify-content-center align-items-center">
          <Loader width={40} />
        </div>
      }
    >
      <Routes>
        <Route
          path=""
          element={
            // <Layout>
            <Home />
            // </Layout>
          }
        />
        <Route path="blog/:id?" element={<Blog />} />
        <Route path="article/:articleId" element={<Article />} />
        <Route path="product/:id" element={<SingleProduct />} />
        <Route path="all-pages" element={<AllPages />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/store" element={<Store />} />

        <Route
          path="category/:id"
          element={
            // <Layout>
            <Category />
            // </Layout>
          }
        />

        <Route
          path="customer-panel/profile"
          element={
            <ProtectedRoute>
              <CustomerLayout>
                <Profile />
              </CustomerLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="customer-panel/messages"
          element={
            <ProtectedRoute>
              <CustomerLayout>
                <CustomerMessage />
              </CustomerLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="customer-panel/orders"
          element={
            <ProtectedRoute>
              <CustomerLayout>
                <CustomerOrders />
              </CustomerLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="customer-panel/favorites"
          element={
            <ProtectedRoute>
              <CustomerLayout>
                <FavoritePage />
              </CustomerLayout>
            </ProtectedRoute>
          }
        />

        {/* admin panel: */}
        <Route
          path="admin-panel/dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/financial"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminFinancial />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/orders"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminOrders />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/user-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <UserManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        {/* سرنخ */}
        <Route
          path="admin-panel/clue-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ClueManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        {/* کمپین */}
        <Route
          path="admin-panel/campain-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CampainManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        {/* مدیریت دسته بندی */}
        <Route
          path="admin-panel/category-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CategoryManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        {/*مدیریت ویژگی ها*/}
        <Route
          path="admin-panel/option-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <OptionManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/brand-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <BrandManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        {/* Appointment Management Routes */}
        <Route
          path="admin-panel/appointment-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AppointmentManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/service-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ServiceManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/schedule-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ScheduleManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/blocked-dates-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <BlockedDatesManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/reservation-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ReservationManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        {/* باشگاه مشتریان */}
        {/* <Route
          path="admin-panel/customer-club"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CustomerClub />
              </AdminLayout>
            </ProtectedRoute>
          }
        /> */}
        {/* تک پست */}
        <Route path="blog/post/:id" element={<DetailPost />} />
        <Route
          path="/coming-soon"
          element={<div className="text-center fs-5 my-3">به زودی ...</div>}
        />
        {/* <Route
          path="/category/:id"
          element={
            <CustomerLayout>
              <SubCategory />
            </CustomerLayout>
          }
        /> */}
        <Route path="/upload-excel" element={<UploadExcel />} />
        <Route path="/appointment-system" element={<AppointmentSystem />} />
        <Route path="/reservation-form" element={<ReservationForm />} />
        
        {/* Appointment Booking Routes */}
        <Route path="/appointment-booking" element={<AppointmentBooking />} />
        <Route path="/appointment-booking/select-time/:serviceId" element={<SelectTime />} />
        <Route path="/appointment-booking/confirm/:serviceId/:date/:time" element={<ConfirmAppointment />} />
      </Routes>
    </Suspense>
  );
}
